import React from "react";
import Information from "../information/Information";

const InternalViewMultipleSessions = () => (
  <Information headerText="You have an existing session">
    <div id="multipleSessionsStatus">
      Your previous session had not ended. Please ensure you end each session
      before starting a new one. Please close all Member Online browser windows
      (including this one) and then try again.
    </div>
  </Information>
);

export default InternalViewMultipleSessions;
